import type { ChapterId } from '../state/GameState';

export interface AssetManifestEntry {
  key: string;
  type: 'tilemap' | 'image' | 'spritesheet';
  url: string;
  frameConfig?: { frameWidth: number; frameHeight: number };
  chapter?: ChapterId;
  preload: boolean;
}

export const assetManifest = [
  {
    key: 'map.home',
    type: 'tilemap',
    url: 'assets/data/map.home.json',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'map.rain_station',
    type: 'tilemap',
    url: 'assets/data/map.rain_station.json',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'map.shared_life',
    type: 'tilemap',
    url: 'assets/data/map.shared_life.json',
    chapter: 'life',
    preload: true,
  },
  {
    key: 'map.return_corridor',
    type: 'tilemap',
    url: 'assets/data/map.return_corridor.json',
    chapter: 'return',
    preload: true,
  },
  {
    key: 'map.home_ending',
    type: 'tilemap',
    url: 'assets/data/map.home_ending.json',
    chapter: 'ending',
    preload: true,
  },
  {
    key: 'environment.home.background',
    type: 'image',
    url: 'assets/environments/environment_home_v11.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'environment.home.sunlight_overlay',
    type: 'image',
    url: 'assets/environments/environment_home_sunlight_overlay_v02.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'environment.home.crosswall_overlay',
    type: 'image',
    url: 'assets/environments/environment_home_crosswall_overlay_v02.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'environment.home.frontwall_overlay',
    type: 'image',
    url: 'assets/environments/environment_home_frontwall_overlay_v02.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'environment.rain.background',
    type: 'image',
    url: 'assets/environments/environment_rain_base_v02.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'environment.rain.puddle_reflection_overlay',
    type: 'image',
    url: 'assets/environments/environment_rain_puddle_reflection_overlay_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'environment.rain.rain_overlay',
    type: 'image',
    url: 'assets/environments/environment_rain_rain_overlay_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'environment.life.background',
    type: 'image',
    url: 'assets/environments/environment_life_v02.png',
    chapter: 'life',
    preload: true,
  },
  {
    key: 'environment.life.resolved',
    type: 'image',
    url: 'assets/environments/environment_life_resolved_v01.png',
    chapter: 'life',
    preload: true,
  },
  {
    key: 'environment.return.background',
    type: 'image',
    url: 'assets/environments/environment_return_v02.webp',
    chapter: 'return',
    preload: true,
  },
  {
    key: 'environment.ending.background',
    type: 'image',
    url: 'assets/environments/environment_ending_v02.webp',
    chapter: 'ending',
    preload: true,
  },
  {
    key: 'character.xu_old.idle.down',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_idle_down_v01_4x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.idle.up',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_idle_up_v01_4x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.idle.right',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_idle_right_v01_4x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.walk.down',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_walk_down_v01_6x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.walk.up',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_walk_up_v01_6x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.walk.right',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_walk_right_v01_6x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.observe.down',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_observe_down_v01_4x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.observe.up',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_observe_up_v01_4x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.observe.right',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_observe_right_v01_4x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.pickup.down',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_pickup_down_v01_6x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xu_old.pickup.right',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_pickup_right_v01_6x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    preload: true,
  },
  {
    key: 'character.xiulan_old.reach_hand.right',
    type: 'spritesheet',
    url: 'assets/characters/character_xiulan_old_reach_hand_right_v01_8x64x96.png',
    frameConfig: { frameWidth: 64, frameHeight: 96 },
    chapter: 'ending',
    preload: true,
  },
  {
    key: 'character.xu_old.hold_hand.side',
    type: 'spritesheet',
    url: 'assets/characters/character_xu_old_hold_hand_side_v01_4x512x256.png',
    frameConfig: { frameWidth: 512, frameHeight: 256 },
    chapter: 'ending',
    preload: true,
  },
  {
    key: 'prop.red_umbrella.closed',
    type: 'image',
    url: 'assets/props/prop_red_umbrella_closed_v01.png',
    preload: true,
  },
  {
    key: 'prop.rain.ticket',
    type: 'image',
    url: 'assets/props/prop_rain_ticket_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'prop.rain.stone_2',
    type: 'image',
    url: 'assets/props/prop_rain_stone_2_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'prop.rain.stone_4',
    type: 'image',
    url: 'assets/props/prop_rain_stone_4_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'prop.rain.stone_5',
    type: 'image',
    url: 'assets/props/prop_rain_stone_5_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'prop.rain.umbrella_sign_a',
    type: 'image',
    url: 'assets/props/prop_rain_umbrella_sign_a_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'prop.rain.umbrella_sign_b',
    type: 'image',
    url: 'assets/props/prop_rain_umbrella_sign_b_v01.png',
    chapter: 'rain',
    preload: true,
  },
  {
    key: 'prop.home.bedside_photo',
    type: 'image',
    url: 'assets/props/prop_home_bedside_photo_v01.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'prop.home.red_thread_journal',
    type: 'image',
    url: 'assets/props/prop_home_red_thread_journal_v01.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'prop.home.blue_key_bowl',
    type: 'image',
    url: 'assets/props/prop_home_blue_key_bowl_v01.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'prop.home.glasses_case',
    type: 'image',
    url: 'assets/props/prop_home_glasses_case_v01.png',
    chapter: 'home',
    preload: true,
  },
  {
    key: 'prop.life.shared_life.atlas',
    type: 'spritesheet',
    url: 'assets/props/prop_life_shared_life_atlas_v02_10x128x128.png',
    frameConfig: { frameWidth: 128, frameHeight: 128 },
    chapter: 'life',
    preload: true,
  },
  {
    key: 'prop.life.photo.move_1979',
    type: 'image',
    url: 'assets/props/prop_life_photo_move_1979_v02.png',
    chapter: 'life',
    preload: false,
  },
  {
    key: 'prop.life.photo.osmanthus_1992',
    type: 'image',
    url: 'assets/props/prop_life_photo_osmanthus_1992_v02.png',
    chapter: 'life',
    preload: false,
  },
  {
    key: 'prop.life.photo.anniversary_2001',
    type: 'image',
    url: 'assets/props/prop_life_photo_anniversary_2001_v02.png',
    chapter: 'life',
    preload: false,
  },
  {
    key: 'decor.home.atlas',
    type: 'spritesheet',
    url: 'assets/decor/decor_home_atlas_v02_6x256x256.png',
    frameConfig: { frameWidth: 256, frameHeight: 256 },
    chapter: 'home',
    preload: true,
  },
  {
    key: 'furniture.home.atlas',
    type: 'spritesheet',
    url: 'assets/furniture/furniture_home_atlas_v08_7x256x256.png',
    frameConfig: { frameWidth: 256, frameHeight: 256 },
    chapter: 'home',
    preload: true,
  },
  {
    key: 'memory.rain.umbrella.illustration',
    type: 'image',
    url: 'assets/memories/memory_rain_umbrella_v01.webp',
    chapter: 'rain',
    preload: false,
  },
  {
    key: 'memory.life.move.illustration',
    type: 'image',
    url: 'assets/memories/memory_life_move_v01.webp',
    chapter: 'life',
    preload: false,
  },
  {
    key: 'memory.life.osmanthus.illustration',
    type: 'image',
    url: 'assets/memories/memory_life_osmanthus_v01.webp',
    chapter: 'life',
    preload: false,
  },
  {
    key: 'memory.life.cassette.illustration',
    type: 'image',
    url: 'assets/memories/memory_life_cassette_v01.webp',
    chapter: 'life',
    preload: false,
  },
  {
    key: 'memory.ending.hand.illustration',
    type: 'image',
    url: 'assets/memories/memory_ending_hand_v01.webp',
    chapter: 'ending',
    preload: false,
  },
] as const satisfies readonly AssetManifestEntry[];

export function assetUrl(key: (typeof assetManifest)[number]['key']): string {
  const asset = assetManifest.find((entry) => entry.key === key);
  if (!asset) throw new Error(`Unknown asset key: ${key}`);
  return asset.url;
}
